export const ROLE_HOME = { er: "/separacao", operacional_lite: "/" };
export const ROLE_ALLOWED = {
  er: ["/picklist", "/reposicao", "/separacao"],
  operacional_lite: ["/", "/ocorrencias", "/sla", "/inventario", "/picklist", "/reposicao", "/separacao", "/auditoria"],
};
